import React from 'react';

const FooterSection = () => <div></div>;

export default FooterSection;
